import { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Dashboard } from '@bemap/ui';
import { ISession } from '@bemap/utils';
import { ANALYST_ROUTES } from '@bemap/utils';
import { FunnelProvider } from '@bemap/crm-microfrontends';
import PeoplePage from '../pages/people/people-page';
import AssessmentPage from '../pages/assessments/assessment-page';
import GroupAnalysisPage from '../pages/assessments/group-analysis-page';
import AssessmentResultsPage from '../pages/assessments/assessment-results-page';
import CompaniesPage from '../pages/companies/companies-page';
import ViewCompanyPage from '../pages/companies/view-company';
import ListsPage from '../pages/lists/lists-page';
import ViewListPage from '../pages/lists/view-list';
import AnalystDashboard from '../pages/dashboards/analyst';
import ProfileEditPage from '../pages/profile-edit';
import StudentDashboard from '@/pages/dashboards/student';
import Courses from '@/pages/Courses';
import CourseEnrollment from '@/pages/CourseEnrollment';
import University from '@/pages/University';
import CourseCertificatesPage from '@/pages/certificates/course-certificates';
import LeadsPage from '@/pages/leads/leads-page';
import ViewLeadPage from '@/pages/leads/view-lead';
import CampaignLinksPage from '@/pages/campaign-links/campaign-links-page';
import CrmPage from '@/pages/crm/crm-page';
import CrmOverviewPage from '@/pages/crm/crm-overview-page';
import FunnelSettingsPage from '@/pages/crm/funnel-settings-page';
import { FunnelSelector } from '@/components/crm/FunnelSelector';

const appVersion = __APP_VERSION__
interface ProtectedLayoutProps {
  user: ISession | null;
}

const AnalystRoutes: FC<ProtectedLayoutProps> = ({ user }) => {

  return (
    <FunnelProvider>
      <Dashboard user={user} funnelSelector={<FunnelSelector />} appVersion={appVersion}>
      <Routes>
        <Route path="/" element={<Navigate to={ANALYST_ROUTES.DASHBOARD} replace />} />
        <Route path={ANALYST_ROUTES.DASHBOARD} element={<AnalystDashboard />} />
        <Route path={ANALYST_ROUTES.ASSESSMENTS} element={<AssessmentPage />} />
        <Route path={ANALYST_ROUTES.ASSESSMENTS_GROUP} element={<GroupAnalysisPage />} />
        <Route path={ANALYST_ROUTES.ASSESSMENTS_VIEW} element={<AssessmentResultsPage />} />
        <Route path={ANALYST_ROUTES.PEOPLE} element={<PeoplePage />} />
        <Route path={ANALYST_ROUTES.LEADS} element={<LeadsPage />} />
        <Route path={ANALYST_ROUTES.LEADS_VIEW} element={<ViewLeadPage />} />
        <Route path={ANALYST_ROUTES.CAMPAIGN_LINKS} element={<CampaignLinksPage />} />
        <Route path={ANALYST_ROUTES.CRM} element={<CrmPage />} />
        <Route path={ANALYST_ROUTES.CRM_OVERVIEW} element={<CrmOverviewPage />} />
        <Route path={ANALYST_ROUTES.CRM_FUNNEL_SETTINGS} element={<FunnelSettingsPage />} />
        <Route path={ANALYST_ROUTES.COMPANIES} element={<CompaniesPage />} />
        <Route path={ANALYST_ROUTES.COMPANIES_VIEW} element={<ViewCompanyPage />} />
        <Route path={ANALYST_ROUTES.GROUPS} element={<ListsPage />} />
        <Route path={ANALYST_ROUTES.GROUPS_VIEW} element={<ViewListPage />} />
        <Route path={ANALYST_ROUTES.PROFILE} element={<ProfileEditPage />} />
        <Route path={ANALYST_ROUTES.STUDENT_DASHBOARD} element={<StudentDashboard />} />
        <Route path={ANALYST_ROUTES.UNIVERSITY} element={<StudentDashboard />} />
        <Route path={ANALYST_ROUTES.UNIVERSITY_CERTIFICATES} element={<CourseCertificatesPage />} />
        <Route path={ANALYST_ROUTES.UNIVERSITY_COURSES} element={<Courses />} />
        <Route path={ANALYST_ROUTES.UNIVERSITY_COURSES_VIEW} element={<University />} />
        <Route path={ANALYST_ROUTES.UNIVERSITY_COURSES_CONTENT} element={<University />} />
        <Route path={ANALYST_ROUTES.UNIVERSITY_COURSES_ENROLL} element={<CourseEnrollment />} />
        <Route path="*" element={<Navigate to={ANALYST_ROUTES.DASHBOARD} replace />} />
      </Routes>
    </Dashboard>
    </FunnelProvider>
  );
};

export default AnalystRoutes; 